import { useState } from 'react';
import { Box, Fade, Popper, Link, Typography } from '@mui/material';

import { pushGAEvent } from '@widget/analytics';
import { attachCurrentQueryParams } from '@widget/utils/attachCurrentQueryParams';

import type { NavigatinItemProps } from './types';
import type { FC, MouseEvent } from 'react';

export const DesktopNavigationItem: FC<NavigatinItemProps> = ({ navItem }) => {
  const hasChildren = !!navItem.children?.length;

  const [showSubmenu, setShowSubmenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const onLinkMouseEnter = (event: MouseEvent<HTMLElement>): void => {
    if (!hasChildren) return;

    if (event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }

    setShowSubmenu(true);
  };

  const onLinkMouseLeave = (): void => {
    setShowSubmenu(false);
  };

  return (
    <Box
      sx={{ marginRight: 2, '&:last-child': { marginRight: 0 } }}
      display="flex"
      onMouseEnter={onLinkMouseEnter}
      onMouseLeave={onLinkMouseLeave}
    >
      <Link
        href={attachCurrentQueryParams(navItem.link.url)}
        color={'primary'}
        underline="none"
        onClick={() => {
          pushGAEvent('navigation_click', {
            label: navItem.name,
            info: 'header',
          });
        }}
      >
        <Typography color={'primary'} noWrap={true}>
          {navItem.name}
        </Typography>
      </Link>
      <Popper
        id="submenu-dropdown"
        open={showSubmenu}
        anchorEl={anchorEl}
        transition
        placement="bottom-start"
        style={{ zIndex: 3001 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Box
              display="flex"
              width="100%"
              flexDirection="column"
              bgcolor="#ffffff"
              mt={4}
              boxShadow="0px 2px 8px rgb(0 0 0 / 12%)"
            >
              {navItem.children?.map((subItem) => (
                <Link
                  key={subItem.name}
                  href={attachCurrentQueryParams(subItem.link.url)}
                  underline="none"
                  onClick={() => {
                    pushGAEvent('subnavigation_click', {
                      label: subItem.name,
                      info: navItem.name,
                    });
                  }}
                  color={'primary'}
                  py={1}
                  px={2}
                  borderBottom="1px solid rgba(0, 0, 0, 0.05)"
                >
                  <Typography color={'primary'} noWrap={true}>
                    {subItem.name}
                  </Typography>
                </Link>
              ))}
            </Box>
          </Fade>
        )}
      </Popper>
    </Box>
  );
};
